"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.RegisterUserInformation = void 0;
var _LabelValueDisplay = _interopRequireDefault(require("01_core/components/layout/LabelValueDisplay"));
var _labelConsts = require("01_core/constants/labelConsts");
var _stringUtil = _interopRequireDefault(require("01_core/logics/stringUtil"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const LABEL_WIDTH = 200;

/**
 * 個人情報設定 ユーザ情報
 */
const RegisterUserInformation = function (props) {
  const {
    userInfo,
    intl
  } = props;
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_FULL_NAME
    }),
    value: _stringUtil.default.emptyToHyphen(userInfo.shainNm),
    labelWidth: LABEL_WIDTH
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      lg: 6
    }
  }), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_COMPANY_NAME
    }),
    value: _stringUtil.default.emptyToHyphen(userInfo.kaishaNm),
    labelWidth: LABEL_WIDTH
  })), /*#__PURE__*/_react.default.createElement(_Grid.default, {
    size: {
      xs: 12,
      lg: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_LabelValueDisplay.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.CORE_ORGANIZATION_NAME
    }),
    value: _stringUtil.default.emptyToHyphen(userInfo.soshikiNmFull),
    labelWidth: LABEL_WIDTH
  })));
};
exports.RegisterUserInformation = RegisterUserInformation;
RegisterUserInformation.propTypes = {
  // Parent
  userInfo: _propTypes.default.object,
  // injectIntl
  intl: _propTypes.default.object
};
var _default = exports.default = (0, _reactIntl.injectIntl)(RegisterUserInformation);